import { createRouter, createWebHistory } from "vue-router";
// import { isEqual } from "lodash";
import RechnerView from "../views/rechner/RechnerView.vue";
import ErgebnisView from "../views/rechner/ErgebnisView.vue";
import AntragfragenView from "../views/rechner/AntragfragenView.vue";
import PersonalfragenView from "../views/rechner/PersonalfragenView.vue";
import AntragOkView from "../views/rechner/AntragOkView.vue";
//seo

import HomeView from "../views/site/HomeView.vue";


const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // test componente
  {
    path: "/vergleich/ergebnis/:token",
    name: "ergebnis",
    component: ErgebnisView,
  },
  {
    path: "/angebot/kostenlos/:tarif_id/:token",
    name: "antragfragen",
    component: AntragfragenView,
  },
  {
    path: "/angebot/es_hat_geklappt/:tarif_id/:token",
    name: "antragfragenok",
    component: AntragOkView,
  },
  {
    path: "/angebot/kostenlos_fertig/:tarif_id/:token",
    name: "personalfragen",
    component: PersonalfragenView,
  },
  {
    path: "/start",
    name: "rechner",
    component: RechnerView,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
